module.exports = __webpack_public_path__ + "img/confirm_bgleft1.f723bc3b.png";